import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";

@Component({
    selector: "adapt-team-private-icon",
    templateUrl: "./team-private-icon.component.html",
    styles: `:host { display: contents; }`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TeamPrivateIconComponent {
    public static readonly IconClass = "fas fa-lock-alt ms-1"; // this will be reused by nav node builder

    public readonly iconClass = TeamPrivateIconComponent.IconClass; // used by template
    @Input() public team?: Team;
    @Input() public showTooltip = true;
}
